import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ButtonType } from '@ascschool/interface/setting';
import { CategoryModel } from '@ascschool/model/category/category-model.model';
import { Level } from '@ascschool/model/category/level.model';
import { CommonFilter } from '@ascschool/model/commonfilter/commonfilter';
import { Student } from '@ascschool/model/school/student.model';
import { AuthQuery } from '@ascschool/core/auth/auth.query';
import { AuthService } from '@ascschool/core/auth/auth.service';
import { ConfirmComponent } from '@ascschool/project/popups/confirm/confirm.component';
import { SizePageService } from '@ascschool/project/size-page/size-page.service';
import { LevelService } from '@ascschool/services/category/level.service';
import { ProvinceService } from '@ascschool/services/category/province.service';
import { TypeOfDisabilityService } from '@ascschool/services/category/typeofdisability.service';
import { DepartmentOfEducationAndTrainingService } from '@ascschool/services/organization/department-of-educatio-and-training.service';
import { SchoolService } from '@ascschool/services/organization/school.service';
import { FolkService } from '@ascschool/services/school/folk.service';
import { StudentService } from '@ascschool/services/school/student.service';
import { UtilsService } from '@ascschool/services/utils.service';
import { ShortcutInput } from 'ng-keyboard-shortcuts';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { NzUploadChangeParam } from 'ng-zorro-antd/upload';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { StudentImportPupupComponent } from './import-hoc-sinh/pop-up-import-hoc-sinh.component';
import { StudentPopupComponent } from './sua-hoc-sinh-popup/student-popup.component';
import { StudentAddPopupComponent } from './them-hoc-sinh-popup/student-add-popup.component';
import { StudentViewComponent } from './xem-hoc-sinh/student-view.component';
import { TrichXuatThongTinPupupComponent } from './trich-xuat-thong-tin/pop-up-trich-xuat-thong-tin.component';
import { DistrictService } from '@ascschool/services/category/district.service';
@Component({
  selector: 'app-hoc-sinh',
  templateUrl: './hoc-sinh.component.html',
  styleUrls: ['./hoc-sinh.component.scss']
})
export class HocSinhComponent implements OnInit, OnDestroy {
  isResizdePopup: boolean;
  dialogRef: NzModalRef;
  titlePopup: string;
  @ViewChild('tplTitle', { static: false }) titlePopupElement;
  total: number = 0;
  firstRowOnPage: any;
  searchAdvanced = false;
  divisibleForFour: boolean;
  checkedAll: boolean = false;

  getProvinceACFn: (value: any) => Observable<any>;
  provinceSubscription: any;
  provinceControl = new FormControl();

  getSchoolACFn: (value: any) => Observable<any>;
  schoolSubscription: any;
  schoolControl = new FormControl();

  getSoGDACFn: (value: any) => Observable<any>;
  SoGDSubscription: any;
  SoGDControl = new FormControl();

  getPhongGDACFn: (value: any) => Observable<any>;
  phongGDSubscription: any;
  phongGDControl = new FormControl();

  getFolkACFn: (value: any) => Observable<any>;
  FolkSubscription: any;
  FolkControl = new FormControl();

  getTypeOfDisabilityACFn: (value: any) => Observable<any>;
  TypeOfDisabilitySubscription: any;
  TypeOfDisabilityControl = new FormControl();

  getLevelACFn: (value: any) => Observable<any>;
  LevelSubscription: any;
  LevelControl = new FormControl();

  getDistrictACFn: (value: any) => Observable<any>;
  DistrictSubscription: any;
  DistrictControl = new FormControl()


  listStudent: Student[];
  listStudentSelected: number[];
  constructor(
    private msg: NzMessageService, private cdRef: ChangeDetectorRef, public _authService: AuthService,
    public sizePageService: SizePageService, private modalService: NzModalService, private authQuery: AuthQuery,
    private service: StudentService, public utilService: UtilsService, private provinceService: ProvinceService,
    private districtService: DistrictService, private soGDService: DepartmentOfEducationAndTrainingService,
    private typeOfDisabilityService: TypeOfDisabilityService, private levelService: LevelService,
    private schoolService: SchoolService, private folkService: FolkService,
  ) {
    this.currentUser = JSON.parse(localStorage.getItem('userSetting'));
  }
  get breadcrumbs(): string[] {
    return ['Quản lý người khuyết tật'];
  }
  // tslint:disable-next-line: adjacent-overload-signatures
  @ViewChild('pageHeaderTable', { static: false }) set content2(content2: ElementRef) {
    if (content2) {
      // initially setter gets called with undefined
      this.elementPageHeaderTable = content2;
    }
  }
  @ViewChild('pageOptionBtnGroup', { static: false }) elementpageOptionBtnGroup: ElementRef;
  @ViewChild('pageSearch', { static: false }) elementPageSearch: ElementRef;
  private elementPageHeaderTable: ElementRef;
  currentUser: any;
  buttonTypeEnum = ButtonType;
  btnType: ButtonType;
  shortcuts: ShortcutInput[] = [];
  commonFilter = new CommonFilter();
  searchTerm: string = '';
  pageIndex: number = 1;
  categoryModel = new CategoryModel();
  pageSizeOptions: number[] = [50, 100, 200];
  pageSize: number = this.pageSizeOptions[1];
  loading: boolean = true;
  width: number;
  numberControl: number;
  show = false;
  maxHeight: number;
  height: number;
  heightPopup: number;
  heightPagnagation: number = 50;
  isCollapse = true;
  isDisabled : boolean = false;
  isDisabled1 : boolean = false;
  isDisabled2 : boolean = false;
  unsubscribe$ = new Subject();
  sortNameFn = (a, b) => a.fullName.localeCompare(b.fullName);
  ngOnInit() {
    if(this.currentUser.accountType === 3){
      this.isDisabled = true;
    }else if(this.currentUser.accountType === 1){
      this.isDisabled1 = true;
    }else if(this.currentUser.accountType === 2){
      this.isDisabled2 = true;
    }
    if (this.currentUser.accountType === 3) {
      this.commonFilter.ProvinceId = this.currentUser.provinceId;
    }
    if (this.currentUser.accountType === 3) {
      this.provinceService.getSelectPagingProvinceById(this.currentUser.provinceId).subscribe(res => {
        this.provinceControl.setValue({ id: res.id, text: res.provinceName });
        //School
        this.getSchoolACFn = (value: any) => this.schoolService.getSelectPagingForStaff({
          searchTerm: value, ProvinceId: this.currentUser.provinceId, SubordinateTypeId: 0, PageIndex: 1, PageSize: 100
        }).pipe(map(resp => resp.results.length > 0
          ? resp.results.map(x => ({ id: x.id, text: x.educationAndTrainingName })) : [{ id: null, text: 'Không có dữ liệu' }]));
        if (!this.schoolSubscription) {
          this.schoolSubscription = this.schoolControl.valueChanges.subscribe(() => {
            this.utilService.bindOrUnBindTheId(this.commonFilter, 'SchoolId', this.schoolControl.value);
          });
        }
        //Quận huyện
        this.getDistrictACFn = (value: any) => this.districtService.getDistrictSelectPaging({
          searchTerm: value, ProvinceId: this.currentUser.provinceId, PageIndex: 1, PageSize: 100
        }).pipe(map(resp => resp.results.length > 0
          ? resp.results.map(x => ({ id: x.id, text: x.districtName })) : [{ id: null, text: 'Không có dữ liệu' }]));
        if (!this.DistrictSubscription) {
          this.DistrictSubscription = this.DistrictControl.valueChanges.subscribe(() => {
            this.utilService.bindOrUnBindTheId(this.commonFilter, 'DistrictId', this.DistrictControl.value);
          });
        }
      });
      //get school
      this.schoolService.GetSelectPagingById(this.currentUser.eadId).subscribe(response => {
        this.schoolControl.setValue({
          ProvinceId: this.currentUser.provinceId, id: response.id, text: response.educationAndTrainingName
        })
      });
      //get quận huyện
      this.districtService.getSelectPagingDistrictById(this.currentUser.districtId).subscribe(response => {
        this.DistrictControl.setValue({ id: response.id, text: response.districtName });
      });
      this.reload();
    }
    if (this.currentUser.accountType === 1) {
      this.provinceService.getSelectPagingProvinceById(this.currentUser.provinceId).subscribe(res => {
        this.provinceControl.setValue({ id: res.id, text: res.provinceName });

        this.getDistrictACFn = (value: any) => this.districtService.getDistrictSelectPaging({
          searchTerm: value, ProvinceId: this.currentUser.provinceId, PageIndex: 1, PageSize: 100
        }).pipe(map(resp => resp.results.length > 0
          ? resp.results.map(x => ({ id: x.id, text: x.districtName })) : [{ id: null, text: 'Không có dữ liệu' }]));
        if (!this.DistrictSubscription) {
          this.DistrictSubscription = this.DistrictControl.valueChanges.subscribe(() => {
            this.utilService.bindOrUnBindTheId(this.commonFilter, 'DistrictId', this.DistrictControl.value);
          });

          this.getSchoolACFn = (value: any) => this.schoolService.getSelectPagingForStaff({
            searchTerm: value, ProvinceId: this.currentUser.provinceId, SubordinateTypeId: 0, PageIndex: 1, PageSize: 100
          }).pipe(map(resp => resp.results.length > 0
            ? resp.results.map(x => ({ id: x.id, text: x.educationAndTrainingName })) : [{ id: null, text: 'Không có dữ liệu' }]));
          if (!this.schoolSubscription) {
            this.schoolSubscription = this.schoolControl.valueChanges.subscribe(() => {
              this.utilService.bindOrUnBindTheId(this.commonFilter, 'SchoolId', this.schoolControl.value);
            });
          }
        }
      });
      this.reload();
    }
    if (this.currentUser.accountType === 1) {
      this.commonFilter.subordinateTypeId = this.currentUser.eadId;
    } else {
      this.commonFilter.subordinateTypeId = 0;
    }
    if (this.currentUser.accountType === 2) {
      this.provinceService.getSelectPagingProvinceById(this.currentUser.provinceId).subscribe(res => {
        this.provinceControl.setValue({ id: res.id, text: res.provinceName });
        this.getDistrictACFn = (value: any) => this.districtService.getDistrictSelectPaging({
          searchTerm: value, ProvinceId: this.currentUser.provinceId, PageIndex: 1, PageSize: 100
        }).pipe(map(resp => resp.results.length > 0
          ? resp.results.map(x => ({ id: x.id, text: x.districtName })) : [{ id: null, text: 'Không có dữ liệu' }]));
        if (!this.DistrictSubscription) {
          this.DistrictSubscription = this.DistrictControl.valueChanges.subscribe(() => {
            this.utilService.bindOrUnBindTheId(this.commonFilter, 'DistrictId', this.DistrictControl.value);
          });
        }
        this.districtService.getSelectPagingDistrictById(this.currentUser.districtId).subscribe(response => {
          this.DistrictControl.setValue({ id: response.id, text: this.currentUser.eadName });
          this.reload();
        });
      });

      this.getSchoolACFn = (value: any) => this.schoolService.getSelectPagingForStaff({
        searchTerm: value, ProvinceId: this.currentUser.provinceId, SubordinateTypeId: 0, PageIndex: 1, PageSize: 100
      }).pipe(map(resp => resp.results.length > 0
        ? resp.results.map(x => ({ id: x.id, text: x.educationAndTrainingName })) : [{ id: null, text: 'Không có dữ liệu' }]));
      if (!this.schoolSubscription) {
        this.schoolSubscription = this.schoolControl.valueChanges.subscribe(() => {
          this.utilService.bindOrUnBindTheId(this.commonFilter, 'SchoolId', this.schoolControl.value);
        });
      }
      this.reload();
    }

    this.commonFilter.PageIndex = 1;
    this.commonFilter.PageSize = this.pageSizeOptions[1];
    this.reload();
    this.maxHeight = window.innerHeight;
    this._authService.getNavChangeEmitter().subscribe(item => {
      this.checkCaculateHeight();
    });
    this.authQuery.userSetting$.subscribe(type => {
      if (type) {
        this.btnType = type.btnType;
      }
    });
    this.loadProvince();
    this.loadFolk();
    this.loadTypeOfDisability();
    this.loadLevel();
    if (this.isCollapse) {
      this.divisibleForFour = this.isDivisibleForFour(4);
    } else {
      this.divisibleForFour = this.isDivisibleForFour(12);
    }
  }
  ngOnDestroy() {
    console.log(this.unsubscribe$);
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  reload() {
    this.loading = true;
    this.checkedAll = false;
    this.service.get(this.commonFilter).pipe(
        takeUntil(this.unsubscribe$)
    ).subscribe((response: any) => {
      this.total = (response && response.rowCount) ? response.rowCount : 0;
      this.firstRowOnPage = (response && response.firstRowOnPage) ? response.firstRowOnPage : 0;
      this.listStudent = response.results ? response.results : [];
      this.loading = false;
      this.listStudent.map(x => x.checked = false);
      this.listStudentSelected = [];
    }, (err: any) => {
      this.listStudent = [];
      this.listStudentSelected = [];
      this.loading = false;
    }
    );
  }

  search() {
    this.commonFilter.PageIndex = 1;
    this.reload();
  }
  pageIndexEvent(pageE: any) {
    this.commonFilter.PageIndex = pageE;
    this.pageIndex = pageE;
    this.reload();
  }
  pageSizeEvent(pageE: any) {
    this.commonFilter.PageSize = pageE;
    this.pageSize = pageE;
    this.reload();
  }
  ngAfterViewInit() {
    this.checkCaculateHeight(this.isCollapse);
    // keyboard
    this.shortcuts.push({
      key: ["alt + n"], label: "Help", description: "Cmd + b",
      command: (e) => this.PopupAdd(), preventDefault: true
    });
    this.cdRef.detectChanges();
  }
  isDivisibleForFour(index: number) {
    if (index % 4 === 0) {
      return true;
    } else {
      return false;
    }
  }
  checkCaculateHeight(isOpen?: boolean) {
    setTimeout(() => {
      this.height = this.heightfnc();
      this.width = this.widthfnc();
    }, 1);
  }
  heightfnc() {
    return this.sizePageService.caculateHeight(
      this.elementpageOptionBtnGroup,
      this.elementPageSearch,
      this.elementPageHeaderTable,
      this.heightPagnagation);
  }
  widthfnc() {
    return this.sizePageService.caculateWidth(this.elementPageSearch);
  }
  caculateHeightPopup(maxHeight: number): number {
    let heightModal: number;
    if (maxHeight > 950) {
      return (heightModal = 700 + (maxHeight - 860));

    } else {
      return (heightModal = 700 - (860 - maxHeight));
    }
  }
  onResize() {
    this.width = this.widthfnc();
    this.checkCaculateHeight(this.isCollapse);
  }
  handleChange(info: NzUploadChangeParam): void {
    if (info.file.status !== 'uploading') {
    }
    if (info.file.status === 'done') {
      this.msg.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      this.msg.error(`${info.file.name} file upload failed.`);
    }
  }
  toggleCollapse(): void {
    this.maxHeight = window.innerHeight;
    this.isCollapse = !this.isCollapse;
    this.checkCaculateHeight(this.isCollapse);
  }
  resetForm(): void {
  }
  //popupAdd
  PopupAdd(): void {
    if (this.currentUser.accountType !== 3) {
      if (this.commonFilter.SchoolId && this.commonFilter.SchoolId > 0) {
        this.isResizdePopup = false;
        this.titlePopup = 'Thêm - Thông tin về người khuyết tật';
        this.dialogRef = this.modalService.create({
          nzTitle: this.titlePopupElement,
          nzContent: StudentAddPopupComponent,
          nzStyle: { top: '30px' },
          nzMaskClosable: false,
          nzBodyStyle: {
            overflow: 'auto',
            maxheight: this.caculateHeightPopup(window.innerHeight) + 'px',
            height: this.caculateHeightPopup(window.innerHeight) + 'px',
          },
          nzComponentParams: { educationAndTrainingOrSchoolId: this.commonFilter.SchoolId },
          nzWidth: 1500
        });
        // const instance = dialogRef.getContentComponent();
        this.dialogRef.afterClose.subscribe(results => {
          if (results) {
            this.reload();
          }
        });
      } else {
        this.msg.warning('Vui lòng chọn Cơ sở để thêm!');
      }
    } else {
      this.isResizdePopup = false;
      this.titlePopup = 'Thông tin người khuyết tật';
      this.dialogRef = this.modalService.create({
        nzTitle: this.titlePopupElement,
        nzContent: StudentAddPopupComponent,
        nzStyle: { top: '30px' },
        nzMaskClosable: false,
        nzBodyStyle: {
          overflow: 'auto',
          maxheight: this.caculateHeightPopup(window.innerHeight) + 'px',
          height: this.caculateHeightPopup(window.innerHeight) + 'px',
        },
        nzComponentParams: { educationAndTrainingOrSchoolId: this.currentUser.eadId },
        nzWidth: 1500
      });
      // const instance = dialogRef.getContentComponent();
      this.dialogRef.afterClose.subscribe(results => {
        if (results) {
          this.reload();
        }
      });
    }
  }

  //popupAdd
  PopupEdit(item: any): void {
    this.isResizdePopup = false;
    this.titlePopup = 'Chỉnh sửa - Thông tin về người khuyết tật';
    this.dialogRef = this.modalService.create({
      nzTitle: this.titlePopupElement,
      nzContent: StudentPopupComponent,
      nzStyle: { top: '30px' },
      nzMaskClosable: false,
      nzBodyStyle: {
        overflow: 'auto',
        maxheight: this.caculateHeightPopup(window.innerHeight) + 'px',
        height: this.caculateHeightPopup(window.innerHeight) + 'px',
      },
      nzComponentParams: { dataTransmission: item },
      nzWidth: 1500
    });
    // const instance = dialogRef.getContentComponent();
    this.dialogRef.afterClose.subscribe(results => {
      if (results) {
        this.reload();
      }
    });
  }

  PopupView(item: any): void {
    this.isResizdePopup = false;
    this.titlePopup = 'Xem - Thông tin về người khuyết tật';
    this.dialogRef = this.modalService.create({
      nzTitle: this.titlePopupElement,
      nzContent: StudentViewComponent,
      nzStyle: { top: '30px' },
      nzMaskClosable: false,
      nzBodyStyle: {
        overflow: 'auto',
        maxheight: this.caculateHeightPopup(window.innerHeight) + 'px',
        height: this.caculateHeightPopup(window.innerHeight) + 'px'
      },
      nzComponentParams: { dataTransmission: item },
      nzWidth: 1500
    });
    // const instance = dialogRef.getContentComponent();
    this.dialogRef.afterClose.subscribe(results => {
      if (results) {
        this.reload();
      }
    });
  }

  ImportData(): void {
    if (this.commonFilter.SchoolId) {
      const dialogRef = this.modalService.create({
        nzTitle: 'Import Học sinh',
        nzContent: StudentImportPupupComponent,
        nzStyle: { top: '30px' },
        nzMaskClosable: false,
        nzBodyStyle: { overflow: 'auto', },
        nzComponentParams: { schoolId: this.commonFilter.SchoolId },
        nzWidth: 700
      });
      // const instance = dialogRef.getContentComponent();
      dialogRef.afterClose.subscribe(results => {
        if (results) {
          this.reload();
        }
      });
    } else {
      this.msg.warning('Vui lòng chọn Cơ sở!');
    }
  }

  TrichXuat(): void {
    this.listStudentSelected = [];
    this.setOfCheckedId.forEach(item => {
      this.listStudentSelected.push(item);
    });
    if (this.listStudentSelected.length > 0) {
      const dialogRef = this.modalService.create({
        nzTitle: 'Trích xuất thông tin Người khuyết tật',
        nzContent: TrichXuatThongTinPupupComponent,
        nzStyle: { top: '30px' },
        nzMaskClosable: false,
        nzBodyStyle: { overflow: 'auto' },
        nzComponentParams: { lstId: this.setOfCheckedId },
        nzWidth: 1200
      });
      // const instance = dialogRef.getContentComponent();
      dialogRef.afterClose.subscribe(results => {
        if (results) {
          this.reload();
        }
      });
    } else {
      this.msg.warning('Vui lòng chọn người khuyết tật!');
    }
  }

  deleteMulti(): void {
    this.listStudentSelected = [];
    this.setOfCheckedId.forEach(item => {
      this.listStudentSelected.push(item);
    });
    if (this.listStudentSelected.length > 0) {
      const dialogRef = this.modalService.create({
        nzTitle: 'Xóa thông tin người khuyết tật',
        nzContent: ConfirmComponent,
        nzComponentParams: { description: 'thông tin người khuyết tật đã chọn' },
        nzStyle: { top: '20px' },
        nzMaskClosable: false,
      });
      dialogRef.afterClose.subscribe(results => {
        if (results) {
          this.service.deleteMulti(this.listStudentSelected).subscribe((res: any) => {
            this.msg.success('Cập nhật thông tin ' + res.message);
            this.reload();
          });
        }
      });
    } else {
      this.msg.warning('Bạn chưa chọn dữ liệu cần xóa');
    }
  }
  notification(response) {
    if (response.statusCode === 0) {
      this.msg.success('Cập nhật thông tin ' + response.message);
    } else {
      this.msg.error('Lỗi: ' + response.message);
    }
  }

  clear() {
    this.SoGDControl.setValue(null);
    this.phongGDControl.setValue(null);
    if(this.currentUser.accountType === 6 || this.currentUser.accountType === 5){
      this.provinceControl.setValue(null);
    }else if(this.currentUser.accountType === 6 || this.currentUser.accountType === 5 || this.currentUser.accountType === 1){
      this.DistrictControl.setValue(null);
    }else if(this.currentUser.accountType !== 3){
      this.schoolControl.setValue(null);
    }
    this.TypeOfDisabilityControl.setValue(null);
    this.LevelControl.setValue(null);
    this.FolkControl.setValue(null);
    delete this.commonFilter.StudyOfYear;
    this.commonFilter.FullName = '';
    this.commonFilter.StudentCode = '';
    delete this.commonFilter.Gender;
    delete this.commonFilter.disDisabilityCertificateType;
    delete this.commonFilter.supportSpecificEquipment;
    this.reload();
  }
  exportExcel() {
    this.service.exportExcel(this.commonFilter).subscribe((data) => {
      var downloadURL = window.URL.createObjectURL(data);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download = 'DanhSachNKT.xlsx';
      link.click();
    });
  }
  ///////////////////////////////////////////////////////////////////////////////////////AutoComplete//////////////////////////////////////////////////////////////////
  valueIfHas(control: FormControl) {
    if (control.value && typeof control.value != 'string') { return control.value.id; }
    return '';
  }

  loadProvince() {
    this.getProvinceACFn = (value: any) => this.provinceService.GetSelectPagingProvinceBySubordinateType({
      searchTerm: value, PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.length > 0
      ? resp.map(x => ({ id: x.id, text: x.provinceName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    if (!this.provinceSubscription) {
      this.provinceSubscription = this.provinceControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'ProvinceId', this.provinceControl.value);
      });
    }
  }

  changeProvince(control: FormControl) {
    if (control.value) {
      this.provinceControl = control;
      if (this.currentUser.accountType === 5 || this.currentUser.accountType === 6) {
        this.loadSchool(control.value.id,0);
        this.loadDistrict();
      }
      if (this.currentUser.accountType === 1) {
        this.commonFilter.subordinateTypeId = this.currentUser.eadId;
        this.loadSchool(control.value.id,0);
        this.loadDistrict();
      } else {
        if (this.SoGDControl.value) {
          this.commonFilter.subordinateTypeId = this.SoGDControl.value.id;
          this.loadSchool(control.value.id,0);
          this.loadDistrict();
        } else {
          this.commonFilter.subordinateTypeId = 0;
          this.loadSchool(control.value.id,0);
          this.loadDistrict();
        }
      }
    } else {
      this.schoolControl.setValue(null);
    }
  }

  loadDistrict() {
    this.getDistrictACFn = (value: any) => this.districtService.getDistrictSelectPaging({
      searchTerm: value, ProvinceId: this.valueIfHas(this.provinceControl), PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.districtName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    if (!this.DistrictSubscription) {
      this.DistrictSubscription = this.DistrictControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'DistrictId', this.DistrictControl.value);
      });
    }
  }
  changeDistrictACFn(control: FormControl) {
    this.DistrictControl = control;
    if(this.currentUser.accountType === 2){
      this.commonFilter.subordinateTypeId = this.currentUser.eadId;
      this.loadSchool(this.provinceControl.value.id,this.DistrictControl.value.id)
    }else{
      this.loadSchool(this.provinceControl.value.id,this.DistrictControl.value.id)
    }
  }

  loadSchool(idProvince: number, idDistrict : number) {
    this.getSchoolACFn = (value: any) => this.schoolService.getSelectPagingForStaff({
      searchTerm: value, ProvinceId: idProvince, SubordinateTypeId: this.commonFilter.subordinateTypeId,DistrictId: idDistrict, PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.educationAndTrainingName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    if (!this.schoolSubscription) {
      this.schoolSubscription = this.schoolControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'SchoolId', this.schoolControl.value);
      });
    }
  }

  changeSchool(control: FormControl) {
    this.schoolControl = control;

  }

  loadFolk() {
    this.getFolkACFn = (value: any) => this.folkService.getFolkSelectPaging({
      searchTerm: value, PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.folkName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    if (!this.FolkSubscription) {
      this.FolkSubscription = this.FolkControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'FolkId', this.FolkControl.value);
      });
    }
  }
  changeFolk(control: FormControl) {
    this.FolkControl = control;
  }

  loadTypeOfDisability() {
    this.getTypeOfDisabilityACFn = (value: any) => this.typeOfDisabilityService.getSelectPaging({
      searchTerm: value, PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.typeOfDisabilityName })) : [{ id: null, text: 'Không có dữ liệu' }]));
    if (!this.TypeOfDisabilitySubscription) {
      this.TypeOfDisabilitySubscription = this.TypeOfDisabilityControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'typeOfDisabilityId', this.TypeOfDisabilityControl.value);
      });
    }
  }
  changeTypeOfDisability(control: FormControl) {
    this.TypeOfDisabilityControl = control;
  }

  loadLevel() {
    this.getLevelACFn = (value: any) => this.levelService.getSelectPaging({
      searchTerm: value, PageIndex: 1, PageSize: 100
    }).pipe(map(resp => resp.results.length > 0
      ? resp.results.map(x => ({ id: x.id, text: x.levelName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.LevelSubscription) {
      this.LevelSubscription = this.LevelControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.commonFilter, 'levelId', this.LevelControl.value);
      });
    }
  }
  changeLevel(control: FormControl) {
    this.LevelControl = control;
  }

  checked = false;
  indeterminate = false;
  listOfCurrentPageData: Student[] = [];
  setOfCheckedId = new Set<number>();
  updateCheckedSet(id: number, checked: boolean): void {
    if (checked) {
      this.setOfCheckedId.add(id);
    } else {
      this.setOfCheckedId.delete(id);
    }
  }
  onItemChecked(id: number, checked: boolean): void {
    this.updateCheckedSet(id, checked);
    this.refreshCheckedStatus();
  }
  onAllChecked(value: boolean): void {
    this.listOfCurrentPageData.forEach(item => this.updateCheckedSet(item.id, value));
    this.refreshCheckedStatus();
  }

  onCurrentPageDataChange($event: Student[]): void {
    this.listOfCurrentPageData = $event;
    this.refreshCheckedStatus();
  }

  refreshCheckedStatus(): void {
    this.checked = this.listOfCurrentPageData.every(item => this.setOfCheckedId.has(item.id));
    this.indeterminate = this.listOfCurrentPageData.some(item => this.setOfCheckedId.has(item.id)) && !this.checked;
  }
  handlerResizePopup() {
    this.isResizdePopup = !this.isResizdePopup;
    let width = 1500;
    let height = this.caculateHeightPopup(window.innerHeight) + 'px';
    let top = 30;
    if (this.isResizdePopup === true) {
      width = window.innerWidth;
      top = 15;
      height = this.caculateHeightPopup(window.innerHeight) + 50 + 'px';
    }
    this.dialogRef.updateConfig({
      nzWidth: width,
      nzStyle: { top: top + 'px' },
      nzBodyStyle: { overflow: 'auto', maxheight: height, height: height }
    });
  }

}
